(() => {
  const ROOT_SELECTOR = '[data-paths-faq]';

  function normalize(value = '') {
    return String(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function initPathsFaq(root) {
    if (!root || root.dataset.pathsFaqInitialized === 'true') return;

    root.dataset.pathsFaqInitialized = 'true';

    const searchInput = root.querySelector('[data-paths-faq-search]');
    const clearButton = root.querySelector('[data-paths-faq-clear]');
    const filters = root.querySelector('[data-paths-faq-filters]');

    const filterButtons = Array.from(
      root.querySelectorAll('[data-faq-filter]')
    );

    const items = Array.from(
      root.querySelectorAll('[data-paths-faq-item]')
    );

    const countElement = root.querySelector('[data-paths-faq-count]');
    const emptyState = root.querySelector('[data-paths-faq-empty]');
    const resetButton = root.querySelector('[data-paths-faq-reset]');

    let currentFilter = 'all';
    let currentSearch = '';


    function itemMatches(item) {
      const category = normalize(
        item.dataset.faqCategory || ''
      );

      const searchText = normalize(
        item.dataset.faqSearch || ''
      );

      const categoryMatches =
        currentFilter === 'all' ||
        category === currentFilter;

      const searchMatches =
        currentSearch === '' ||
        searchText.includes(currentSearch);

      return categoryMatches && searchMatches;
    }


    function updateCount(visibleCount) {
      if (!countElement) return;

      countElement.textContent =
        visibleCount === 1
          ? '1 question'
          : `${visibleCount} questions`;
    }


    function closeHiddenItems() {
      items.forEach((item) => {
        if (item.hidden && item.open) {
          item.open = false;
        }
      });
    }


    function applyFilters() {
      let visibleCount = 0;

      items.forEach((item) => {
        const visible = itemMatches(item);

        item.hidden = !visible;

        if (visible) {
          visibleCount += 1;
        }
      });

      closeHiddenItems();

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }

      if (clearButton) {
        clearButton.hidden = currentSearch === '';
      }

      updateCount(visibleCount);
    }


    function setActiveFilter(button) {
      if (!button) return;

      filterButtons.forEach((filterButton) => {
        const isActive = filterButton === button;

        filterButton.classList.toggle(
          'is-active',
          isActive
        );

        filterButton.setAttribute(
          'aria-pressed',
          String(isActive)
        );
      });

      currentFilter = normalize(
        button.dataset.faqFilter || 'all'
      );

      applyFilters();
    }


    function resetFaq() {
      currentFilter = 'all';
      currentSearch = '';

      if (searchInput) {
        searchInput.value = '';
      }

      const allButton = filterButtons.find(
        (button) =>
          normalize(button.dataset.faqFilter) === 'all'
      );

      if (allButton) {
        filterButtons.forEach((button) => {
          const isActive = button === allButton;

          button.classList.toggle(
            'is-active',
            isActive
          );

          button.setAttribute(
            'aria-pressed',
            String(isActive)
          );
        });
      }

      items.forEach((item) => {
        item.open = false;
      });

      applyFilters();

      searchInput?.focus();
    }


    searchInput?.addEventListener('input', (event) => {
      currentSearch = normalize(event.target.value);

      applyFilters();
    });


    searchInput?.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        searchInput.value !== ''
      ) {
        currentSearch = '';
        searchInput.value = '';

        applyFilters();
      }
    });


    clearButton?.addEventListener('click', () => {
      currentSearch = '';

      if (searchInput) {
        searchInput.value = '';
        searchInput.focus();
      }

      applyFilters();
    });


    filters?.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-faq-filter]'
      );

      if (!button) return;

      setActiveFilter(button);
    });


    resetButton?.addEventListener('click', () => {
      resetFaq();
    });


    applyFilters();
  }


  function initAllPathsFaqs(scope = document) {
    scope
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initPathsFaq);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllPathsFaqs();
    });
  } else {
    initAllPathsFaqs();
  }


  document.addEventListener('shopify:section:load', (event) => {
    initAllPathsFaqs(event.target);
  });
})();